/*
// KJR 2014-08-22
// Global JS included on every page.  Add all your common script inits here.
*/

//$(document).ready(function() {
//$(function() { // Shorthand for $( document ).ready()
window.addEventListener('DOMContentLoaded', function() {
	// executes when HTML-Document is loaded and DOM is ready

	
	//pointerdown, touch-action
	 $('.megamenu .nav-item>a').on('touchstart', function(event){
		$('body').removeClass('disable_touchevent');
		if($(this).siblings('.sub-nav').length > 0) {
			event.preventDefault();
			$('.nav-item .open').removeClass('open');
			$(this).addClass('open').siblings('.sub-nav').addClass('open');
		}
	});

	

	//menu toggle
	function pushyOn() {
		//$("#top-nav").css('z-index', 'auto');
		$("body").addClass("pushy-open-right");
		//remove tabindex for all items under pushy div
		$(".pushy").find('a, button').each(function() {
			$(this).removeAttr('tabindex');
		});
	}
	function pushyOff() {
		//$("#top-nav").removeAttr("style");
		$("body").removeClass("pushy-open-right");
		//add tabindex=-1 for all items under pushy div
		$(".pushy").find('a, button').each(function() {
			$(this).attr('tabindex', '-1');
		});
	}
	$(".mobile-nav").click(function () {
		pushyOn();
	});
	$(".pushy-link, .site-overlay").click(function () {
		pushyOff();
	});
	pushyOff();

	//track phone number taps & clicks
	$('.tel').on('click', function(e){
		e.preventDefault();
		trackEvent('Mobile', 'Click to Call', $(this).data('tel'));
		window.location = 'tel:'+$(this).data('tel');
	});

	//hide pushy scrollbar
	$scrollbarWidth = getScrollbarWidth();
	$(".pushy").css('margin-right', '-'+$scrollbarWidth+'px');

	//animate the scroll to top
	addScrollToOnClick('.back2top', 'body', 500);
	$('.search_icon').on('click', 'a', function(event) {
		event.preventDefault();
		$('body').toggleClass('search_open');
		$('body').hasClass('search_open') ? $('#search-field').focus() : $('.search_icon').find('a').first().focus();
	});
	$('.search_close_button').on('click', function(event) {
		event.preventDefault();
		$('.top_navigation').find('a').first().focus();
		$('body').removeClass('search_open');
	});

	//decrypt encrypted mailto links
	$('.mailto').each(function() {
		var strEncrypted = $(this).html();
		var parts = strEncrypted.split("|");
		var email = rot13(decodeBase64(parts[0]));
		var display = rot13(decodeBase64(parts[1]));
		var html = '<a class="email" href="mailto:'+email+'">'+display+'</a>';
		$(this).html(html);
	});

	//decrypt encrypted mailto links
	$('.hrefto').each(function() {
		var strEncrypted = $(this).attr('href');
		var parts = strEncrypted.split("|");
		var email = rot13(decodeBase64(parts[0]));
		var display = rot13(decodeBase64(parts[1]));
		// var html = '<a class="email" href="mailto:'+email+'">'+display+'</a>';
		$(this).attr('href', 'mailto:' + email);
		$(this).html(display);
	});

	//set noopener for all external links
	$('a[target="_blank"]').each(function() {
		var rel = '';
		if ( $(this).attr("rel") ) {
			rel = $(this).attr("rel");
			rel = rel.replace('noopener', '').trim();
			if (rel.length > 0) {
				rel += ' ';
			}
		}
		$(this).attr('rel', rel+'noopener');
	});

	//backward compatibility for accessible mega menu
	$(".megamenu").accessibleMegaMenu({
		uuidPrefix: "accessible-megamenu",
		menuClass: "nav-menu",
		topNavItemClass: "nav-item",
		panelClass: "sub-nav",
		panelGroupClass: "sub-nav-group",
		hoverClass: "hover",
		focusClass: "focus",
		openClass: "open"
	});
	$('a.sub-nav').removeClass('sub-nav');

	//KH svg hack
	var url_regex = /(fill:url\()(\#)([a-zA-Z0-9_]+)\)/g;
	var svg_string = '';
	$('svg.svg_logo').each(function(index, element) {
		var svg_string = $(this).html();
		//$(this).html($(this).html().replace(url_regex, '$1' + '"./rfq.php' + '$2' + '$3' + '")'));
	});

	//KH phone number switcher
	run_location_finder(1, 'html', '.phone_number');
	//$('.phone_number').html(location_data[139].phone);

//}); //End document.ready
}, true); //End document.ready

//window.onload = function() {
window.addEventListener('load', function() {
	// executes when complete page is fully loaded, including all frames, objects and images
//}; //End window.onload
}, true); //End window.onload

var scroll_detect = 0;

$(document).scroll(function() {
	scroll_detect = $(document).scrollTop() < 300 ? 0.9 + $(document).scrollTop() / 3000 : 1;
	$('.header_cont').css('background-color', 'rgba(255, 255, 255, ' + scroll_detect + ')');
});

function update_office_location(office_data, target_location) {
	$('.location_name').html(office_data.office_name);
	$('.location_address').html(office_data.address + '<br />' + office_data.city + ', ' + office_data.state + ' ' + office_data.zip);
	$('.location_phone').html('<b>Phone:</b> <a href="tel:+1-' + office_data.phone + '" class="tel" data-tel="+1-' + office_data.phone + '">' + office_data.phone + '</a>');
	$('.location_fax').empty();
	if(office_data.fax.length !== 0) {
		$('.location_fax').html('<b>Fax:</b> ' + office_data.fax);
	}
	$('.location_toll_free').html('<b>Toll-Free:</b> ' + office_data.phone_to);
	$('.location_toll_free_int').html('<b>Toll-Free (Intl):</b> ' + office_data.phone_ti);
	/*
		<p class="location_fax"><b>Fax:</b> 716-691-1230</p>		<p>Click for a map of all <a href="./locations.php">office locations</a></p>
	</div>
	*/
}

function phone_timeout() {
	$('.top_nav_phone_cont').removeClass('open');
}


function addScrollToOnClick(clickedElm, targetElm, animationDuration) {
	$(clickedElm).click(function(event) {
		event.preventDefault();
		$('html, body').animate({scrollTop: $(targetElm).offset().top}, animationDuration);
		return false;
	});
}

function getScrollbarWidth() {
	var outer = document.createElement("div");
	outer.style.visibility = "hidden";
	outer.style.width = "100px";
	document.body.appendChild(outer);

	var widthNoScroll = outer.offsetWidth;
	// force scrollbars
	outer.style.overflow = "scroll";

	// add innerdiv
	var inner = document.createElement("div");
	inner.style.width = "100%";
	outer.appendChild(inner);

	var widthWithScroll = inner.offsetWidth;

	// remove divs
	outer.parentNode.removeChild(outer);

	return widthNoScroll - widthWithScroll;
}


function getMobileOperatingSystem() {
	var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	if ( userAgent.match( /iPad/i ) || userAgent.match( /iPhone/i ) || userAgent.match( /iPod/i ) ) {
		return 'iOS';
	}
	else if ( userAgent.match( /Android/i ) ) {
		return 'Android';
	}
	else if ( userAgent.match( /Windows Phone/i ) ) {
		return 'Windows Phone';
	}
	else {
		return false;
	}
}

/*
 * jQuery getCSS Plugin
 * Copyright 2013, intesso
 * MIT license.
 *
 * cross browser function to dynamically load an external css file.
 * see: [github page](http://intesso.github.com/jquery-getCSS/)
 *
 */

(function() {
	/*
		arguments: attributes
		attributes can be a string: then it goes directly inside the href attribute.
		e.g.: $.getCSS("fresh.css")
		attributes can also be an objcet.
		e.g.: $.getCSS({href:"cool.css", media:"print"})
		or:	$.getCSS({href:"/styles/forest.css", media:"screen"})
	*/
	var getCSS = function(attributes) {
			// setting default attributes
			if(typeof attributes === "string") {
				var href = attributes;
				attributes = {
					href: href
				};
			}
			if(!attributes.rel) {
				attributes.rel = "stylesheet";
			}
			// appending the stylesheet
			// no jQuery stuff here, just plain dom manipulations
			var styleSheet = document.createElement("link");
			for(var key in attributes) {
				styleSheet.setAttribute(key, attributes[key]);
			}
			var head = document.getElementsByTagName("head")[0];
			head.appendChild(styleSheet);
		};

	if(typeof jQuery === "undefined") {
		window.getCSS = getCSS;
	} else {
		jQuery.getCSS = getCSS;
	}

})();